import WaitingScreen from 'components/WaitingScreen/WaitingScreen';
import { useAppSelector } from 'store/hooks';
import { selectEndSessionData, selectWaitingScreen } from 'features/application/applicationSlice';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';
import { selectRejoinEnabled, selectRoomStatus } from 'features/room/roomSlice';
import { usePageReload } from 'hooks/usePageReload';

const SessionEnded = () => {
  const { t } = useTranslation('waiting-screens');

  const { createReloadUrl } = usePageReload();

  const screen = useAppSelector(selectWaitingScreen);
  const roomStatus = useAppSelector(selectRoomStatus);
  const endSession = useAppSelector(selectEndSessionData);

  const rejoinEnabled = useAppSelector(selectRejoinEnabled);

  const renderContent = () => {
    if (roomStatus === 'ended') {
      if (endSession.endedByMe) {
        return t('end_session.local_user_ended');
      }

      if (endSession.initiatorName) {
        return t('end_session.ended', { username: endSession.initiatorName });
      }

      return t('end_session.ended_unnamed');
    }

    if (roomStatus === 'left') {
      return t('end_session.session_left');
    }

    return null;
  };

  const renderRejoinButton = () => {
    if (screen === 'sessionEnded') {
      return null;
    }

    if (!rejoinEnabled) {
      return null;
    }

    const rejoinUrl = createReloadUrl();

    return (
      <div>
        <Button
          type="button"
          variant="outlined"
          href={rejoinUrl}
          onClick={(e) => {
            e.preventDefault();
            window.location.replace(rejoinUrl);
          }}
        >
          {t('end_session.btn_rejoin')}
        </Button>
      </div>
    );
  };

  return (
    <WaitingScreen show>
      <Typography
        sx={{
          mb: 2,
        }}
      >
        {renderContent()}
      </Typography>
      {renderRejoinButton()}
    </WaitingScreen>
  );
};

export default SessionEnded;
